import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/pause/motion";
import { scrollToId } from "@/lib/smooth";

const offerings = [
  {
    no: "01",
    title: "1-on-1 Sessions",
    desc: "Fully personalised practice built around your body, your goals, and your pace. In person or online.",
    meta: "Private · Weekly or fortnightly",
  },
  {
    no: "02",
    title: "Weekly Practice",
    desc: "Small-group classes that blend breath, movement, and stillness. Consistency without the pressure.",
    meta: "Group · Live & recorded",
  },
  {
    no: "03",
    title: "Retreat Escapes",
    desc: "Off-grid, immersive weekends in nature. Unplug, slow down, and come home to yourself.",
    meta: "Seasonal · Small cohorts",
  },
];

export const Offerings = () => {
  return (
    <section id="offerings" data-testid="offerings-section" className="bg-[#FAF7F2] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="font-body text-xs uppercase tracking-[0.28em] text-[#8C8070] mb-4">How We Practice</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#1A1A1A] mb-14 max-w-3xl">
            Ways to <span className="italic text-[#3B5A3A]">pause</span> with us.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 min-[900px]:grid-cols-3 gap-6">
          {offerings.map((o, i) => (
            <Reveal key={o.no} delay={i * 0.1}>
              <div
                data-testid={`offering-card-${o.no}`}
                className="group h-full rounded-sm border border-[#8C8070]/25 bg-[#FAF7F2] hover:bg-[#1A1A1A] transition-colors duration-500 p-8 md:p-9 flex flex-col cursor-default"
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-2xl text-[#8C8070] group-hover:text-[#F5C800] transition-colors duration-500">
                    {o.no}
                  </span>
                  <ArrowUpRight className="h-6 w-6 text-[#1A1A1A] group-hover:text-[#F5C800] group-hover:rotate-45 transition-all duration-500" />
                </div>

                <h3 className="mt-10 font-display text-3xl md:text-4xl text-[#1A1A1A] group-hover:text-[#FAF7F2] transition-colors duration-500">
                  {o.title}
                </h3>
                <p className="mt-4 font-body text-[#1A1A1A]/65 group-hover:text-[#FAF7F2]/70 leading-relaxed transition-colors duration-500 flex-1">
                  {o.desc}
                </p>
                <span className="mt-8 font-body text-xs uppercase tracking-[0.16em] text-[#8C8070] group-hover:text-[#F5C800] transition-colors duration-500">
                  {o.meta}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <button
            data-testid="offerings-cta"
            onClick={() => scrollToId("#waitlist")}
            className="mt-12 font-body text-sm uppercase tracking-[0.12em] text-[#1A1A1A] inline-flex items-center gap-2 group"
          >
            Enquire about a spot
            <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
